<template>
  <li :class="className">
    <base-button variant="link" @click="onClick" v-bind="$attrs" :disabled="isDisabled" :class="[{[activeClassName] : selected}]">
      <slot />
    </base-button>
  </li>
</template>

<script>
export default {
  name: 'Tab',

  inject: ['activeClassName'],

  props: {
    className: {
      type: String,
      default: 'c-tabs__list-item'
    },
    index: {
      type: Number,
      default: null
    },
    selected: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onClick (event) {
      event.preventDefault()

      this.$emit('click', this.index)
    }
  }
}
</script>
